import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeModeContext = createContext({
  mode: "dark",
  toggleTheme: () => {},
  setThemeMode: () => {}
});

const THEME_STORAGE_KEY = "ticketwhats-admin:theme";

export const ThemeModeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    if (typeof window === "undefined") return "dark";

    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;

    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark";
    }

    return "dark";
  });

  useEffect(() => {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
    if (mode === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [mode]);

  const toggleTheme = () => {
    setMode((prev) => (prev === "light" ? "dark" : "light"));
  };

  const setThemeMode = (newMode) => {
    if (newMode === "light" || newMode === "dark") {
      setMode(newMode);
    }
  };

  return (
    <ThemeModeContext.Provider value={{ mode, toggleTheme, setThemeMode }}>
      {children}
    </ThemeModeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeModeContext);
